import type { IconSvgObject } from './types';

const Tag02Icon: IconSvgObject = [
  ["path", { d: "M8 14L10.0013 16.0038", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 6L22 2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9.58579 20.5858L3.41421 14.4142C2.63317 13.6332 2.63317 12.3668 3.41421 11.5858L10.4142 4.58579C10.7893 4.21071 11.298 4 11.8284 4H20V12.1716C20 12.702 19.7893 13.2107 19.4142 13.5858L12.4142 20.5858C11.6332 21.3668 10.3668 21.3668 9.58579 20.5858Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Tag02Icon;
